import instance from './common';

export default function getCompareFilterData(query, options = {}, http = instance) {
  return http.post('/metrics', query, options);
}
